import { ConfigProvider, Table } from 'antd';
import styled from 'styled-components';

import { CHART_X_FIELD_NAME } from '@/entities/chart/model/constants';
import useChartCandidateTable from '@/features/(charts)/chart-list/hooks/use-chart-candidate-table';
import useColor from '@/hooks/domain/useColor';
import { customScrollbar } from '@/styles/style';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartCandidateTable = (props: Props) => {
  const { columns, dataSource, rowSelection } = useChartCandidateTable(props);
  const color = useColor();

  return (
    <Style>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              borderColor: color.gray300,
              headerBg: color.gray100,
              headerSortActiveBg: color.gray100,
              headerSortHoverBg: color.gray100,
              cellFontSize: 12,
            },
          },
        }}
      >
        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey={(record) => record[CHART_X_FIELD_NAME]}
          rowSelection={rowSelection}
          pagination={false}
          bordered
          scroll={{
            x: 'max-content',
            y: 520,
          }}
        />
      </ConfigProvider>
    </Style>
  );
};

const Style = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  overflow: auto;
  ${customScrollbar};
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td {
    min-width: 60px !important;
    white-space: nowrap !important;
  }
  .ant-table-row.ant-table-row-selected > .ant-table-cell {
    background-color: ${(props) => props.theme.colors.gray100} !important;
    &:hover {
      background-color: ${(props) => props.theme.colors.hover} !important;
    }
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr
    > th {
    border-inline-end: none;
    font-weight: 500;
    &:last-child {
      border-inline-end: 1px solid ${(props) => props.theme.colors.gray400};
    }
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td {
    border-inline-end: none;
    white-space: nowrap;
    &:last-child {
      border-inline-end: 1px solid ${(props) => props.theme.colors.gray400};
    }
  }
`;

export default ChartCandidateTable;
